export const eventAlbumSelectionUploadConstants = {
  generateAlbumSasRequest: "GENERATE_ALBUM_SAS_REQUEST",
  generateAlbumSasSuccess: "GENERATE_ALBUM_SAS_SUCCESS",
  generateAlbumSasFailure: "GENERATE_ALBUM_SAS_FAILURE",

  uploadAlbumImagesRequest: "UPLOAD_ALBUM_IMAGES_REQUEST",
  uploadAlbumImagesProgress: "UPLOAD_ALBUM_IMAGES_PROGRESS",
  uploadAlbumImagesSuccess: "UPLOAD_ALBUM_IMAGES_SUCCESS",
  uploadAlbumImagesFailure: "UPLOAD_ALBUM_IMAGES_FAILURE",

  stageAlbumFiles: "STAGE_ALBUM_FILES",
  removeAlbumStagedFile: "REMOVE_ALBUM_STAGED_FILE",
  clearAlbumStagedFiles: "CLEAR_ALBUM_STAGED_FILES",

  listAlbumCuratedMediaRequest: "LIST_ALBUM_CURATED_MEDIA_REQUEST",
  listAlbumCuratedMediaSuccess: "LIST_ALBUM_CURATED_MEDIA_SUCCESS",
  listAlbumCuratedMediaFailure: "LIST_ALBUM_CURATED_MEDIA_FAILURE",

  clearAlbumUploadState: "CLEAR_ALBUM_UPLOAD_STATE",
  resetAlbumTemplateState: "RESET_ALBUM_TEMPLATE_STATE",
} as const;
